import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../../Footer';
import { POSTS } from './blogData';
import './Blog.css';

const CATEGORY_COLORS = {
    'Classes': '#c8a97e',
    'Origins': '#8fbc8f',
    'Coffee Education': '#87CEEB',
};

export default function Blog() {
    useEffect(() => {
        document.title = 'The Roast Journal — Coffee Education & Stories | OFFF THE ROAST';
    }, []);

    return (
        <>
            <div className='blog-page'>
                <div className='blog-hero'>
                    <h1 className='blog-hero-title'>THE ROAST JOURNAL</h1>
                    <p className='blog-hero-sub'>Stories, origins, and everything coffee</p>
                </div>

                <div className='blog-container'>
                    <div className='blog-grid'>
                        {POSTS.map((post) => (
                            <Link to={`/blog/${post.slug}`} key={post.slug} className='blog-card'>
                                <div className='blog-card-image'>
                                    {post.image && (
                                        <img
                                            src={post.image}
                                            alt={post.title}
                                            className='blog-card-img'
                                        />
                                    )}
                                    <div className='blog-card-image-overlay' />
                                    <span
                                        className='blog-card-category'
                                        style={{ borderColor: CATEGORY_COLORS[post.category] || '#c8a97e', color: CATEGORY_COLORS[post.category] || '#c8a97e' }}
                                    >
                                        {post.category}
                                    </span>
                                </div>
                                <div className='blog-card-body'>
                                    <p className='blog-card-date'>{post.date}</p>
                                    <h2 className='blog-card-title'>{post.title}</h2>
                                    <p className='blog-card-excerpt'>{post.excerpt}</p>
                                    <span className='blog-card-read'>Read More →</span>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}
